import { SET_DELETE_CATERING_CART } from "../actions";

const deleteCateringCart = (state = [], action) => {
  switch (action.type) {
    case SET_DELETE_CATERING_CART:
      return [...action.value];
    default:
      return state;
  }
};

export default deleteCateringCart;
